import { useEffect, useState } from "react";
import { MdKeyboardArrowLeft, MdOutlineKeyboardArrowRight, MdFirstPage, MdLastPage  } from "react-icons/md";
import view from "../../images/view.png";
import { useLocation } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import NotificationHeader from "./NotificationHeader";
import axios from 'axios';
import { MARK_AS_READ } from "../ApiDetails.js";


function notificationListPage() {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const handleSnackbarOpen = () => setSnackbarOpen(true);
  const [selectedEmail, setSelectedEmail] = useState(null); // Selected email details

  //TODO: How to remove unused event param.
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [emails, setEmails] = useState([]);
  const [countOfNotification, setCountOfNotification] = useState([]);

  const SeeEmail = async (email) => {
    setSelectedEmail(email);

    const response = await axios.get(`${MARK_AS_READ}/${email.id}`);
    if (response.status !== 200) {
        alert("Failed to mark the notification as read.");
    } else {
        setCountOfNotification(Math.max(countOfNotification-1,0));
        email.NotificationMarkedAsRead = true;
    }
    handleSnackbarOpen();
  };

  const location = useLocation();
  const { state } = location || {};
  const data = state?.message;

  useEffect(() => {
    if (data) {
      setEmails(data);
      setCountOfNotification(data.length);
    }
  }, [data]);

  useEffect(() => {
    if (snackbarOpen && !selectedEmail?.emailMessage) {
      const timer = setTimeout(() => {
        setSnackbarOpen(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [snackbarOpen, selectedEmail]);

  useEffect(() => {
    calculateTotalPages(emails);
  }, [emails]);

  const calculateTotalPages = (data) => {
    const total = Math.ceil(data.length / pageSize);
    setTotalPages(total);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;

    let startPage = Math.max(
      1,
      currentPage - Math.floor(maxPageNumbersToShow / 2)
    );
    let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage + 1 < maxPageNumbersToShow) {
      startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const currentPageData = emails.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <>
      <NotificationHeader emails={countOfNotification} />
      <div>
        <div className="container-fluid">
          <div className="row m-4">
            <div className="m-2 bg-light rounded p-3">
              <div className="large-custom-font">Email Notification</div>
            </div>
            <Snackbar
              open={snackbarOpen}
              onClose={handleSnackbarClose}
              message={
                selectedEmail?.emailMessage ? (
                  <div
                    style={{
                      fontFamily: "Mars Centra",
                      color: "#FFFFFF",
                      textAlign: "left",
                      maxHeight: "500px",
                      padding: "16px",
                      overflowY: "auto",
                    }}
                    dangerouslySetInnerHTML={{ __html: selectedEmail.emailMessage }}
                  ></div>
                ) : (
                  "No Data to show"
                )
              }
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              ContentProps={{
                sx: {
                  backgroundColor: "#00008b",
                  color: "#FFFFFF",
                  maxWidth: "600px",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                  textAlign: "center", // Center the fallback message
                },
              }}
              onClick={handleSnackbarClose}
            />
            <div className="m-2 bg-light rounded p-0">
              <div className="container-fluid listitemsadmin listitems p-2">
                <div className="table-responsive">
                  <div className="table">
                    <div className="row custom-table-font-header bg-light p-3 rounded m-3">
                      <div className="col-12 col-md-2">To</div>
                      <div className="col-12 col-md-2">CC</div>
                      <div className="col-12 col-md-4">Subject</div>
                      <div className="col-12 col-md-2">Email Received Date</div>
                      <div className="col-12 col-md-1">Read</div>
                    </div>
                    {currentPageData.length > 0 ? (
                      currentPageData.map((email, index) => (
                        <div
                          className="row custom-table-tr bg-light p-2 rounded m-3 align-items-center"
                          key={index}
                        >
                          <div className="col-12 col-md-2">{email.emailTo}</div>
                          <div className="col-12 col-md-2">{email.emailCC}</div>
                          <div className="col-12 col-md-4">{email.emailSubject}</div>
                          <div className="col-12 col-md-2">{new Date(email.emailSendDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}</div>
                          <div className="col-12 col-md-1">{email.NotificationMarkedAsRead ? "Yes" : "No"}</div>

                          <div className="col-12 col-md-1 text-end">
                            <button
                              className="btn btn-icon"
                              onClick={() => SeeEmail(email)}

                            >
                              <img
                                src={view}
                                alt="Edit"
                                width={24}
                                height={24}
                              />
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="row bg-light p-2 rounded m-3 align-items-center">
                        <div className="col-12 text-center">No Email Found</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
                <div className="paging align-items-center" style={{userSelect: 'none'}}>
                    <span className="centered-text">
                        {(totalPages>0) && (<>{(currentPage - 1) * pageSize + 1}-{Math.min(currentPage * pageSize, emails.length)} OF{" "}</>)}
                        {emails.length} ELEMENTS &nbsp;&nbsp;
                    </span>
                    <nav>
                        <ul className="pagination justify-content-end" style={{ marginBottom: "17px", cursor: "pointer" }}>
                            <li className={`page-item ${((totalPages===0) || currentPage === 1) ? "disabled" : ""}`}>
                                <span className="page-link" onClick={() => handlePageChange(1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdFirstPage /></span>
                            </li>
                            <li className={`page-item ${((totalPages===0) || currentPage === 1) ? "disabled" : ""}`}>
                                <span className="page-link" onClick={() => handlePageChange(currentPage - 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdKeyboardArrowLeft /></span>
                            </li>
                            {getPageNumbers().map((number) => (
                                <li key={number} className={`page-item ${currentPage === number ? "active" : ""}`}>
                                    <span className="page-link" onClick={() => handlePageChange(number)} style={{ fontSize: "12px", padding: "4px 8px" }}>{number}</span>
                                </li>
                            ))}
                            <li className={`page-item ${((totalPages===0) || currentPage === totalPages) ? "disabled" : ""}`}>
                                <span className="page-link" onClick={() => handlePageChange(currentPage + 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdOutlineKeyboardArrowRight /></span>
                            </li>
                            <li className={`page-item ${((totalPages===0) || currentPage === totalPages) ? "disabled" : ""}`}>
                                <span className="page-link" onClick={() => handlePageChange(totalPages)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdLastPage /></span>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default notificationListPage;